import type { EditorModes } from './types';

// Action type constants
export const H5PEDITOR_OPEN = 'H5PEDITOR_OPEN';
export const H5PEDITOR_CLOSE = 'H5PEDITOR_CLOSE';
export const H5PEDITOR_CHANGEMODE = 'H5PEDITOR_CHANGEMODE';
export const H5PEDITOR_SETCONTENTPARAMS = 'H5PEDITOR_SETCONTENTPARAMS';
export const H5PEDITOR_SETSHOWEXPORTDIALOG = 'H5PEDITOR_SETSHOWEXPORTDIALOG';

export const H5PEDITOR_LOADEDITORCONTENT_REQUEST = 'H5PEDITOR_LOADEDITORCONTENT_REQUEST';
export const H5PEDITOR_LOADEDITORCONTENT_SUCCESS = 'H5PEDITOR_LOADEDITORCONTENT_SUCCESS';
export const H5PEDITOR_LOADEDITORCONTENT_FAILURE = 'H5PEDITOR_LOADEDITORCONTENT_FAILURE';

export const H5PEDITOR_UPDATEEDITORCONTENT_REQUEST = 'H5PEDITOR_UPDATEEDITORCONTENT_REQUEST';
export const H5PEDITOR_UPDATEEDITORCONTENT_SUCCESS = 'H5PEDITOR_UPDATEEDITORCONTENT_SUCCESS';
export const H5PEDITOR_UPDATEEDITORCONTENT_FAILURE = 'H5PEDITOR_UPDATEEDITORCONTENT_FAILURE';

export const H5P_EXPORT_REQUEST = 'H5P_EXPORT_REQUEST';
export const H5P_EXPORT_SUCCESS = 'H5P_EXPORT_SUCCESS';
export const H5P_EXPORT_FAILURE = 'H5P_EXPORT_FAILURE';
export const H5P_EXPORT_UPDATE = 'H5P_EXPORT_UPDATE';

// Action interfaces
export interface IH5PEditorOpenAction {
  type: typeof H5PEDITOR_OPEN;
  payload: {
    contentId: string;
  };
}

export interface IH5PEditorCloseAction {
  type: typeof H5PEDITOR_CLOSE;
  payload: Record<string, never>;
}

export interface IH5PEditorChangeModeAction {
  type: typeof H5PEDITOR_CHANGEMODE;
  payload: {
    mode: EditorModes;
  };
}

export interface IH5PEditorSetContentParamsAction {
  type: typeof H5PEDITOR_SETCONTENTPARAMS;
  payload: {
    library: string;
    params: string;
    metadata: any;
    contentHash: string;
  };
}

export interface IH5PEditorSetShowExportDialogAction {
  type: typeof H5PEDITOR_SETSHOWEXPORTDIALOG;
  payload: {
    showExportDialog: boolean;
  };
}

export interface IH5PEditorLoadEditorContentRequestAction {
  type: typeof H5PEDITOR_LOADEDITORCONTENT_REQUEST;
  payload: string;
}

export interface IH5PEditorLoadEditorContentSuccessAction {
  type: typeof H5PEDITOR_LOADEDITORCONTENT_SUCCESS;
  payload: {
    content: string;
    contentHash: string;
  };
}

export interface IH5PEditorLoadEditorContentFailureAction {
  type: typeof H5PEDITOR_LOADEDITORCONTENT_FAILURE;
  payload: any;
}

export interface IH5PEditorUpdateEditorContentRequestAction {
  type: typeof H5PEDITOR_UPDATEEDITORCONTENT_REQUEST;
  payload: {
    contentId: string;
    h5p: any;
    folderId: string;
    workspaceId: string;
  };
}

export interface IH5PEditorUpdateEditorContentSuccessAction {
  type: typeof H5PEDITOR_UPDATEEDITORCONTENT_SUCCESS;
  payload: {
    contentId: string;
    h5p: any;
    folderId: string;
    workspaceId: string;
  };
}

export interface IH5PEditorUpdateEditorContentFailureAction {
  type: typeof H5PEDITOR_UPDATEEDITORCONTENT_FAILURE;
  payload: string;
  folderId: string;
  workspaceId: string;
}

export interface IH5PExportRequestAction {
  type: typeof H5P_EXPORT_REQUEST;
  payload: {
    contentId: string;
    type: 'h5p' | 'htmlbundle' | 'htmlexternal' | 'scorm';
    options?: {
      showRights?: boolean;
      restrictWidthAndCenter?: boolean;
      masteryScore?: number;
      marginX?: number;
      marginY?: number;
      maxWidth?: number;
      showEmbed?: boolean;
    };
  };
}

export interface IH5PExportSuccessAction {
  type: typeof H5P_EXPORT_SUCCESS;
  payload: {
    downloadUrl: string;
  };
}

export interface IH5PExportFailureAction {
  type: typeof H5P_EXPORT_FAILURE;
  payload: Error;
}

export interface IH5PExportUpdateAction {
  type: typeof H5P_EXPORT_UPDATE;
  payload: {
    progress: number;
  };
}

// Union type for all H5P Editor actions
export type H5PEditorActionTypes =
  | IH5PEditorOpenAction
  | IH5PEditorCloseAction
  | IH5PEditorChangeModeAction
  | IH5PEditorSetContentParamsAction
  | IH5PEditorSetShowExportDialogAction
  | IH5PEditorLoadEditorContentRequestAction
  | IH5PEditorLoadEditorContentSuccessAction
  | IH5PEditorLoadEditorContentFailureAction
  | IH5PEditorUpdateEditorContentRequestAction
  | IH5PEditorUpdateEditorContentSuccessAction
  | IH5PEditorUpdateEditorContentFailureAction
  | IH5PExportRequestAction
  | IH5PExportSuccessAction
  | IH5PExportFailureAction
  | IH5PExportUpdateAction;
